// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Vx9J1cFQl-BGZPAgN1ioZ","indicator":"_1tYSZZqeHKEbM2YK1wH2GR","label":"IaDIK94Aw6c7GTMYU13wM","referentialPrice":"-UwIDF5Z-Gb6DddQVP4PX","icon":"_3DUNyAwHJDk6CX9QWP0V0U","group":"_1wXuxo_trPk6dbXWRlLSGw"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Indicators/styles.css
// module id = 1617
// module chunks = 85